import { twMerge } from 'tailwind-merge';
import { AnimatedOpacity } from 'src/animation/AnimatedOpacity';

interface WrapperProps {
  children: React.ReactNode;
  additionalClassName?: string;
  classNameAnimation?: string;
}
export const Wrapper = ({ children, additionalClassName, classNameAnimation }: WrapperProps) => {
  return (
    <div
      className={twMerge(
        '768:min-w-[708px] w-full max-w-[1280px] h-full px-[10px]',
        additionalClassName
      )}>
      <AnimatedOpacity className={classNameAnimation}>{children}</AnimatedOpacity>
    </div>
  );
};
